/*
 * Header background over the repertoar carousel.
 *
 * The carousel cross-fades its slides, so the page background shows through the
 * band halfway. A plain background-color transition on the header goes straight
 * from one colour to the next and stands out. Instead the header gets a layer
 * per slide, in the same stacking order, and each layer copies the opacity and
 * transition Swiper puts on its slide, so both blend the same way.
 */

const CAROUSEL = '.wp-block-post-content > .wp-block-lohko-repertoar-carousel:first-child';
const SCHEME_CLASS = /(?<=^|\s)color-scheme-\S+/;

function initHeaderScheme() {
	const header = document.querySelector<HTMLElement>('.wp-block-lohko-nav-header');
	const carousel = document.querySelector<HTMLElement>(CAROUSEL);
	if (!header || !carousel) {
		return;
	}

	const slides = carousel.querySelectorAll<HTMLElement>(
		'.wp-block-lohko-repertoar-carousel__slide'
	);
	if (slides.length < 2) {
		return;
	}

	const layers = document.createElement('div');
	layers.className = 'site-header__scheme-layers';
	layers.setAttribute('aria-hidden', 'true');

	slides.forEach((slide, index) => {
		const layer = document.createElement('span');
		layer.className = slide.className.match(SCHEME_CLASS)?.[0] ?? '';
		layer.style.transitionTimingFunction = getComputedStyle(slide).transitionTimingFunction;
		layers.append(layer);

		// Until Swiper starts, only the first slide shows.
		const sync = () => {
			layer.style.opacity = slide.style.opacity || (index === 0 ? '1' : '0');
			layer.style.transitionDuration = slide.style.transitionDuration;
		};
		sync();
		new MutationObserver(sync).observe(slide, { attributeFilter: ['style'] });
	});

	header.prepend(layers);
	header.classList.add('has-scheme-layers');
}

window.addEventListener('DOMContentLoaded', initHeaderScheme);
